export default function optimizedOut() {}



// WEBPACK FOOTER //
// ./src/optimized-out.js